import { render, staticRenderFns } from "./InvitationItem.vue?vue&type=template&id=cc5c8b3a&scoped=true&"
import script from "./InvitationItem.vue?vue&type=script&lang=js&"
export * from "./InvitationItem.vue?vue&type=script&lang=js&"
import style0 from "./InvitationItem.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./InvitationItem.vue?vue&type=style&index=1&id=cc5c8b3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5c8b3a",
  null
  
)

export default component.exports